module.exports = __webpack_public_path__ + "static/media/logo-light-big.7e5c73ce.png";